// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"b7da0f51","231":"089a80b5","673":"31d6cfe0","724":"3497638a","746":"9d962207","879":"31d6cfe0","943":"31d6cfe0","956":"43322c23","982":"31d6cfe0"}[chunkId] + ".chunk.css";
};